import { Paper, Stack, Text } from '@mantine/core';

import { formatHumanizedDuration } from '@feature/utils';
import { Validation } from '@feature/validation/ValidationTypes';

interface ValidationCardProps {
  validation: Validation;
}

export function CompactValidationCard({ validation }: ValidationCardProps) {
  return (
    <Paper p="sm">
      <Stack gap="4px">
        {validation.status === 'VALIDATED' && (
          <Text
            fw="500"
            size="sm"
            c="green"
          >
            Validat
          </Text>
        )}
        {validation.status === 'REJECTED' && (
          <Text
            fw="500"
            size="sm"
            c="red"
          >
            Respins
          </Text>
        )}
        <Text
          size="xs"
          fw="500"
        >
          {validation.validatedBy.name}
        </Text>
        <Text
          size="xs"
          c="dimmed"
          fs="italic"
        >
          {formatHumanizedDuration(validation.createdAt)}
        </Text>
      </Stack>
    </Paper>
  );
}
